import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { MobileUpsellComponent } from '@upsell/components/mobile/mobile-upsell.component';
import {
  MobileUpsellPlaceholderComponent
} from '@upsell/components/mobile/placeholders/mobile-upsell-placeholder/mobile-upsell-placeholder.component';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { DesktopUpsellComponent } from '@upsell/components/desktop/desktop-upsell.component';
import { UpsellPlaceholderComponent } from '@upsell/components/desktop/placeholders/upsell-placeholder.component';
import { upsellFeatureName, UpsellModuleState } from '@upsell/store/state/upsell-module.state';
import { UpsellEffect } from '@upsell/store/effects/upsell.effect';
import { upsellRootReducer } from '@upsell/store/reducers';
import { UpsellService } from '@upsell/services/upsell.service';
import { UpsellOptionEffects } from '@upsell/store/effects/upsell-option.effects';
import { UpsellSectionComponent } from '@upsell/components/upsell-section/upsell-section.component';
import { CarouselModule } from '@app/modules/carousel/carousel.module';
import { UpsellFacade } from '@upsell/upsell.facade';
import {
  MobileUpsellBySectorComponent
} from '@upsell/components/mobile/mobile-upsell-by-sector/mobile-upsell-by-sector.component';
import { UpsellFlightDetailsComponent } from '@upsell/components/mobile/upsell-flight-details/upsell-flight-details.component';
import { FlightSegmentConnectionModule } from '@shared/flight-segment-connection/flight-segment-connection.module';
import { LuggageModule } from '@shared/luggage/luggage.module';
import { ProductUpsellModule } from '@ux/components/product-upsell/product-upsell.module';
import { MemberRateTagModule } from '@ux/components/member-rate-tag/member-rate-tag.module';
import { BenefitsModule } from '@shared/benefits/benefits.module';
import { ButtonDsComponent } from '@design-system/components/molecules/button/button.component';
import { FixedSurfaceModule } from '@ux/components/fixed-surface/fixed-surface.module';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { FlightScaleTableDsComponent } from '@design-system/components/organisms/flight-scale-table/flight-scale-table.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { UpsellFooterCardComponent } from '@upsell/components/upsell-footer-card/upsell-footer-card.component';
import { LoaderRingDsComponent } from '@design-system/components/atoms/loader-ring/loader-ring.component';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';
import { RadioButtonDsComponent } from '@design-system/components/organisms/radio-button/radio-button.component';
import { ButtonIconDsComponent } from '@design-system/components/molecules/button-icon/button-icon.component';

export const FEATURE_REDUCER_TOKEN = new InjectionToken<
  ActionReducerMap<UpsellModuleState>
>('Feature Reducers');

@NgModule({
  declarations: [
    MobileUpsellComponent,
    MobileUpsellPlaceholderComponent,
    DesktopUpsellComponent,
    MobileUpsellBySectorComponent,
    UpsellPlaceholderComponent,
    UpsellSectionComponent,
    UpsellFlightDetailsComponent,
    UpsellFooterCardComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    GlobalPipesModule,
    TranslocoModule,
    CarouselModule,
    LuggageModule,
    FlightSegmentConnectionModule,
    LuggageModule,
    ProductUpsellModule,
    StoreModule.forFeature(upsellFeatureName, FEATURE_REDUCER_TOKEN),
    EffectsModule.forFeature([UpsellEffect, UpsellOptionEffects]),
    MemberRateTagModule,
    BenefitsModule,
    FixedSurfaceModule,
    ButtonDsComponent,
    IconDsComponent,
    TypographyDsComponent,
    FlightScaleTableDsComponent,
    LoaderRingDsComponent,
    DividerDsComponent,
    RadioButtonDsComponent,
    ButtonIconDsComponent,
  ],
  exports: [
    MobileUpsellComponent,
    DesktopUpsellComponent,
    MobileUpsellBySectorComponent,
    UpsellFooterCardComponent,
  ],
  providers: [
    UpsellService,
    UpsellFacade,
    {
      provide: FEATURE_REDUCER_TOKEN,
      useValue: upsellRootReducer,
    }
  ]
})
export class UpsellModule { }
